(function (ws) {
    'use strict';
    ws.views.storefrontLogout = ws.views.logout.extend({
        /**
         * Initialize.
         */
        initialize() {
            this.GTM_EVENT_LABEL = this.GTM_STORE_SITE;
            ws.views.logout.prototype.initialize.call(this);
        }
    });
})(westcon);
